import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { getOffsetMonth, formatShortWeekday } from './utils.js';
import { CalendarDot, NextIcon, PrevIcon } from './icons.mjs';

export default function Calendars({ appDiv, currentMonthObj, nextMonthObj, value, onDateChangeHandler, mappedCalendarDays }) {
  const [cal1, setCal1] = useState(currentMonthObj.date);
  const [cal2, setCal2] = useState(nextMonthObj.date);
  const [cal1ActiveStartDate, setCal1ActiveStartDate] = useState(cal1);
  const [cal2ActiveStartDate, setCal2ActiveStartDate] = useState(cal2);

  const tileContent = ({ date, view }) => {
    if (view === 'month') {
      const formattedDate = date.toISOString().split('T')[0];

      if (mappedCalendarDays && mappedCalendarDays.find(d => d.date === formattedDate && d.events.length > 0)) {
        return <CalendarDot />;
      }
    }
  };

  return (
    <>
      <Calendar
        onChange={onDateChangeHandler}
        value={value}
        defaultValue={cal1}
        activeStartDate={cal1ActiveStartDate}
        defaultActiveStartDate={cal1}
        onActiveStartDateChange={({ action, activeStartDate }) => {
          let cal2Div = appDiv.querySelector('.promotions-cal-2');

          switch (action) {
            case 'prev':
              setCal1ActiveStartDate(getOffsetMonth(activeStartDate, -1));
              setCal2ActiveStartDate(getOffsetMonth(activeStartDate, 0));
              cal2Div.classList.remove('invisible');
              break;
            case 'next':
              setCal1ActiveStartDate(getOffsetMonth(activeStartDate, 1));
              setCal2ActiveStartDate(getOffsetMonth(activeStartDate, 2));

              let compareActiveStartDate = getOffsetMonth(activeStartDate, 1);
              let compareMaxMonth = currentMonthObj.nextYear();

              if (
                compareActiveStartDate.getFullYear() === compareMaxMonth.getFullYear()
                && compareActiveStartDate.getMonth() === compareMaxMonth.getMonth()
              ) {
                cal2Div.classList.add('invisible');
              }
              break;
            default:
            // console.log(`This action: ${action} is currently unhandled.`);
          }
        }}
        minDate={currentMonthObj.date}
        maxDate={currentMonthObj.nextYear()}
        minDetail={'month'}
        maxDetail={'month'}
        calendarType={'gregory'}
        formatShortWeekday={formatShortWeekday}
        next2Label={null}
        prev2Label={null}
        nextLabel={<NextIcon />}
        prevLabel={<PrevIcon />}
        tileContent={tileContent}
        calendarAriaLabel="Toggle calendar selection"
        monthAriaLabel="Input month"
        dayAriaLabel="Input day"
        yearAriaLabel="Input year"
        nativeInputAriaLabel="Date"
        nextAriaLabel="Next month"
        prevAriaLabel="Previous month"
      />
      <Calendar
        className="promotions-cal-2"
        onChange={onDateChangeHandler}
        value={value}
        activeStartDate={cal2ActiveStartDate}
        defaultActiveStartDate={cal2}
        minDate={nextMonthObj.firstDay()}
        minDetail={'month'}
        maxDetail={'month'}
        calendarType={'gregory'}
        formatShortWeekday={formatShortWeekday}
        next2Label={null}
        prev2Label={null}
        nextLabel={null}
        prevLabel={null}
        tileContent={tileContent}
        calendarAriaLabel="Toggle calendar selection"
        monthAriaLabel="Input month"
        dayAriaLabel="Input day"
        yearAriaLabel="Input year"
        nativeInputAriaLabel="Date"
        nextAriaLabel="Next month"
        prevAriaLabel="Previous month"
      />
    </>
  );
}
